import {useEffect, useState} from 'react'

export const useUIGameLandscapeResponsive = (containerRef: React.RefObject<HTMLDivElement | null>) => {
    const [containerFontSize, setContainerFontSize] = useState(1)

    useEffect(() => {
        const baseFontSize = 16
        const baseGameHeightPartition = 48
        const baseHeight = baseFontSize * baseGameHeightPartition

        const resizeObserver = new ResizeObserver(() => {
            const containerHeight = containerRef.current?.clientHeight ?? baseHeight
            const newContainerFontSize = containerHeight / baseHeight
            setContainerFontSize(newContainerFontSize)
        })
        if(containerRef.current) resizeObserver.observe(containerRef.current)
        return () => resizeObserver.disconnect()
    }, [])

    return containerFontSize
}
